import styled from "styled-components"
import { Grid } from '@mui/material';



import { topBarSize, leftBarSize } from "../../Components/NavBar/styles";
import { themeChangeTime } from "../../styles/global";

export const GridContainer = styled(Grid)`
    position: absolute;
    top: calc(${topBarSize} + 1rem);
    left: calc(${leftBarSize});

    width: calc(100% - calc(${leftBarSize} + 1.5rem)) !important;
    height: calc(100% - calc(${topBarSize} + 2rem)) !important;

    z-index: 1;
`;

export const GridItem = styled(Grid)`
    background-color: ${(props) => props.theme.body};
    transition: all ${themeChangeTime};
    
    margin-right: 10px !important;
    border-radius: 10px;
    padding: 5px !important;
    border: 1px solid ${(props) => props.theme.border};
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.2);

    width: 20rem !important;
    height: 10rem !important;

    z-index: 2;
`;

export const GridItemTitle = styled.p`
    text-transform: uppercase;
    font-family: 'Roboto';
    font-weight: 900;
    font-size: 1rem;
    color: ${(props) => props.theme.title};
    transition: all ${themeChangeTime};
    padding-left: 0.5rem;

    z-index: 3;
`;
export const GridItemText = styled.p`
    font-family: 'Roboto';
    font-size: 3rem;
    color: #374957;
    font-weight: 100;
    padding-left: 0.5rem;
    text-align: center;

    position: relative;
    top: 35%;
    left: 50%;
    transform: translate(-50%, -50%);

    z-index: 3;
`;

export const GridItemViewMore = styled.a`
    text-decoration: underline;
    font-family: 'Roboto';
    font-size: 0.8rem;
    color: rgba(55, 73, 87, 0.70);
    font-weight: 900;
    position: relative;
    top: 30%;
    left: 2%;

    &:hover{
        color: rgba(55, 73, 87, 1.0);
        cursor: pointer;
        transition-duration: 0.1s;
    }

    z-index: 3;
`;

const GridItemIconSize = "2rem";
export const GridItemIcon = styled.div`
    width: ${GridItemIconSize};
    height: ${GridItemIconSize};
    border-radius: 25%;

    position: relative;
    top: 10%;
    left: 85%;

    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;

    -ms-flex-align: center;
    -webkit-align-items: center;
    -webkit-box-align: center;
    align-items: center;
    justify-content: center;
    color: ${(props) => props.theme.body};
    transition: all ${themeChangeTime};

    z-index: 2;
`;

interface GridItemLoadingProps{
    percentage: number;
}
export const GridItemLoading = styled(GridItemText)<GridItemLoadingProps>`
    width: 8rem;
    height: 8rem;

    border: 5px solid rgb(55, 73, 87, 0.7);
    border-radius: 50%;

    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;

    -ms-flex-align: center;
    -webkit-align-items: center;
    -webkit-box-align: center;
    align-items: center;
    justify-content: center;

    
`;